import { Icon } from '@iconify/react'
import { categoryStamp, decisionIconDescriptor } from '../ui/decisionIcons'
import { ClubCrest } from './ClubCrest'

interface DecisionIconProps {
  art: string
  clubName?: string
}

export function DecisionIcon({ art, clubName }: DecisionIconProps) {
  const descriptor = decisionIconDescriptor(art)

  return (
    <span className={`decision-card__mobile-icon icon-category--${descriptor.category}`} aria-hidden="true">
      {clubName
        ? <ClubCrest name={clubName} size="large" />
        : <Icon className="decision-card__mobile-icon-main" icon={descriptor.icon} />}
      <Icon className="decision-card__mobile-icon-stamp" icon={categoryStamp[descriptor.category]} />
    </span>
  )
}
